import React from 'react';
import { Bell } from 'lucide-react';
import './NotificationBell.css';

interface NotificationBellProps {
  unreadCount: number;
  onClick: () => void;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({
  unreadCount,
  onClick,
}) => {
  return (
    <button
      className="notification-bell"
      onClick={onClick}
      title={`${unreadCount} unread notifications`}
      aria-label={`${unreadCount} unread notifications`}
    >
      <Bell size={16} />
      {unreadCount > 0 && (
        <span className="notification-badge">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};
